import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import SpecialProfiles from "./views/specialprofiles/SpecialProfiles";
import SidervalHotExtruded from "./views/specialprofiles/hotextruded/SidervalHotextruded";
import HSEPHotextruded from "./views/specialprofiles/hotextruded/HSEPHotextruded";
import CalviColddrawn from "./views/specialprofiles/colddrawn/CalviColddrawn";
import HoeschColddrawn from "./views/specialprofiles/colddrawn/HoeschColddrawn";
import BollinghausColddrawn from "./views/colddrawn/BollinghausColddrawn";
import Freeforge from "./views/Freeforge";
import FedrigaFreeForge from "./views/freeforge/FedrigaFreeForge";
import BjorneborgSteelFreeForge from "./views/freeforge/BjorneborgSteelFreeForge";
import Contact from "./views/Contact";
import FalciHotrolled from "@/views/specialprofiles/hotrolled/FalciHotrolled";
import Realisations from "@/views/architecture_constructions/Realisations";
import ExtrudedLightingInsertProfiles from "@/views/architecture_constructions/ExtrudedLightingInsertProfiles";
import ExtrudedProfileGlazedFaceUpright from "@/views/architecture_constructions/ExtrudedProfileGlazedFaceUpright";
import SpecialHandrailProfiles from "@/views/architecture_constructions/SpecialHandrailProfiles";
import NonSlipSteelStairNosing from "@/views/architecture_constructions/NonSlipSteelStairNosing";
import ExtrudedStructuralProfiles from "@/views/architecture_constructions/ExtrudedStructuralProfiles";

Vue.use(Router);

export default new Router({
    linkActiveClass: 'active-link',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/specialprofiles',
            name: 'specialprofiles',
            component: SpecialProfiles
        },
        {
            path: '/specialprofiles/hotrolled/falci',
            name: 'specialprofiles-hotrolled-falci',
            component: FalciHotrolled
        },
        {
            path: '/specialprofiles/hotextruded/hsep',
            name: 'specialprofiles-hotextruded-hsep',
            component: HSEPHotextruded
        },
        {
            path: '/specialprofiles/hotextruded/siderval',
            name: 'specialprofiles-hotextruded-falci',
            component: SidervalHotExtruded
        },
        {
            path: '/specialprofiles/colddrawn/calvi',
            name: 'specialprofiles-colddrawn-calvi',
            component: CalviColddrawn
        },
        {
            path: '/specialprofiles/colddrawn/hoesch',
            name: 'specialprofiles-colddrawn-hoesch',
            component: HoeschColddrawn
        },
        {
            path: '/colddrawn/bollinghaus',
            name: 'colddrawn-bollinghaus',
            component: BollinghausColddrawn
        },
        {
            path: '/freeforge',
            name: 'freeforge',
            component: Freeforge
        },
        {
            path: '/freeforge/fedriga',
            name: 'fedriga',
            component: FedrigaFreeForge
        },
        {
            path: '/freeforge/bjorneborg-steel',
            name: 'bjorneborg-steel',
            component: BjorneborgSteelFreeForge
        },
        {
            path: '/architecture-constructions/realisations',
            name: 'architecture-constructions-realisations',
            component: Realisations
        },
        {
            path: '/architecture-constructions/realisations/extruded-lighting-insert-profile',
            name: 'architecture-constructions-realisations-1',
            component: ExtrudedLightingInsertProfiles
        },
        {
            path: '/architecture-constructions/realisations/extruded-profile-glazed-facade-upright',
            name: 'architecture-constructions-realisations-2',
            component: ExtrudedProfileGlazedFaceUpright
        },
        {
            path: '/architecture-constructions/realisations/special-handrail-profiles',
            name: 'architecture-constructions-realisations-3',
            component: SpecialHandrailProfiles
        },
        {
            path: '/architecture-constructions/realisations/non-slip-steel-stair-nosing',
            name: 'architecture-constructions-realisations-4',
            component: NonSlipSteelStairNosing
        },
        {
            path: '/architecture-constructions/realisations/extruded-structural-profiles',
            name: 'architecture-constructions-realisations-5',
            component: ExtrudedStructuralProfiles
        },
    ]
})